import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        button: {
            width: 100,
        },
        doubleButtons: {
            display: 'inline-flex',
        },
        buttonWrapper: {
            width: 100,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            display: 'flex',
            gap: theme.spacing(1),
        },
    }
})

export default useStyles
